// extracted by mini-css-extract-plugin
export default {"wrapper":"YqfEbUG4q2el_Rbiffdy","input":"IDv_EPhwTQYBoa9Rwfgl","icon":"FQBxFOPbivUlNURJmUCh"};